export { Mail as default } from './Mail';
